var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('closed-card',{staticClass:"account-investigation-closed-card",class:_vm.cardType,attrs:{"title":_vm.formattedAccount,"sub-title":_vm.cardSubtitle}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71ffa9d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/investigations/account-investigation-in-app/AccountInvestigationClosedCard.vue
// module id = null
// module chunks = 